
import { httpss } from "../utils/host";
export const getTopLeaderboardDaily = `${httpss}/apis_v1/leaderboard/daily`;
export const getTopLeaderboardMonthly = `${httpss}/apis_v1/leaderboard/monthly`;
export const getTopLeaderboardAnnual = `${httpss}/apis_v1/leaderboard/yearly`;